module.exports = __webpack_public_path__ + "img/ZVE10LB.b3dde744.jpg";